import React from 'react';
import Markup from '../../../../base/Markup/Markup';
import { TeamGridCardStoryblok } from '../../../../types/storyblok';
import { Type } from '../../../../base/Type/Type';
import { Box } from '../../../../base/Box/Box';
import Link from '../../../../base/Link/Link';
import linkedInDarklogo from '../../../../assets/icons/LinkedIn_Black.svg';
import linkedInWhitelogo from '../../../../assets/icons/LinkedIn_White.svg';
import isDarkColour from '../../../../utils/isDarkColour';

const TeamGridCard = ({ colourScheme }: TeamGridCardStoryblok) => (
  <Box as="article" className="">
    <div
      style={{
        width: '100%',
        height: 300,
      }}
      className="rounded bg-black"
    ></div>
    <Box as="div" className="mb-9 mt-5 flex justify-between">
      <Box as="div">
        <Type as="h2" className="text-p2">
          Henry Lane Fox
        </Type>
        <Type as="p" className="text-p3">
          Co-founder & CEO
        </Type>
      </Box>
      <Link href="">
        <img
          src={
            isDarkColour(colourScheme) && linkedInWhitelogo
              ? linkedInWhitelogo
              : linkedInDarklogo
          }
          height="100%"
          style={{ width: 'auto' }}
        />
      </Link>
    </Box>
    <div className="w-1/5 border border-x-0 border-t-0 border-black"></div>
    {/* Content here */}
  </Box>
);

export default TeamGridCard;
